module.exports = __webpack_public_path__ + "media/images/front/top/sp_app_deprecation-492b05475f075ca7e2d1f7aa812005b8.jpg";